import { REDUCER_NAME } from './addFileToDashboardDialog.reducer';

export const selectIsShowing = state => state[REDUCER_NAME].isShowing;
